import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { QuestionModel } from 'Pages/survey'

export const questionApi = {
	getOne: async (id: number) => {
		const res = await axiosDS().get<QuestionModel>(`${urls.survey.question}/${id}`)
		return res.data
	},
	createOne: async (data: QuestionModel) => {
		const res = await axiosDS().post<QuestionModel>(`${urls.survey.base}/${data?.id}/question`, {
			data,
		})
		return res.data
	},
	updateOne: async (data: QuestionModel) => {
		const res = await axiosDS().patch<QuestionModel>(`${urls.survey.question}/${data.id}`, { data })
		return res.data
	},
	deleteOne: async (id: number) => {
		const res = await axiosDS().delete(`${urls.survey.question}/${id}`)
		return res.data
	},
}
